import { LEGAL_UPDATED, TERMS_MD } from '../content/legal';
import { Markdown } from '../components/Markdown';

/**
 * Página "Termos de Uso". O conteúdo (pt-BR) vive em src/content/legal.ts e é
 * renderizado pelo mesmo componente Markdown usado nas regras.
 */
export function TermsPage(): React.JSX.Element {
  return (
    <>
      <div className="page-head">
        <h1>Termos de Uso</h1>
        <p>Última atualização: {LEGAL_UPDATED}</p>
      </div>

      <div className="rules-content">
        <Markdown source={TERMS_MD} />
      </div>
    </>
  );
}
